module.exports = __webpack_public_path__ + "static/media/cryingFace.76eec80d.png";